import config from '../configs/config'
import BindoService from './base/bindoService'

class ReferenceFormatService extends BindoService {
  async create(storeId, data){
    let path = `v2/stores/${storeId}/reference_numbers`
     return this.post(path, data, config.goApi)
  }
  async getAll(storeId){
    let path = `v2/stores/${storeId}/reference_numbers`
    let {reference_numbers} = await this.get(path, null, config.goApi)
    return reference_numbers
  }
  async update(storeId, data){
    let { id } = data
    let path = `v2/stores/${storeId}/reference_numbers/${id}`
    return await this.put(path, data, config.goApi)
  }
  async delete(storeId, id){
    let path = `v2/stores/${storeId}/reference_numbers/${id}`
    return await super.delete(path, null, config.goApi)
  }
  async getDict(storeId){
    let path = `v2/stores/${storeId}/reference_numbers/related`
    let { reference_number_related } = await this.get(path, null, config.goApi)
    return reference_number_related
  }
}

export default new ReferenceFormatService()



/** WEBPACK FOOTER **
 ** ./client/services/referenceFormatService.js
 **/